import React from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Breadcrumb() {
  const location = useLocation();
  const pathnames = location.pathname.split('/').filter(Boolean); 
  // e.g. "/dashboard/inbound/add-in-bond" → ["dashboard","inbound","add-in-bond"]

  const formatPathName = (path) =>
    path
      .replace(/-/g, ' ')
      .replace(/\b\w/g, (l) => l.toUpperCase()); // Add In Bond

  if (pathnames.length === 0) {
    // when you're at "/", show nothing or show Home text
    return null;
  }

  return (
    <nav className="flex items-center space-x-2 text-sm">
      {pathnames.map((value, index) => {
        const to = '/' + pathnames.slice(0, index + 1).join('/');
        const isLast = index === pathnames.length - 1;

        return (
          <React.Fragment key={to}>
            {index !== 0 && <span className="text-gray-400">•</span>}
            {isLast ? (
              <span className="text-gray-400">{formatPathName(value)}</span>
            ) : (
              <Link
                to={to}
                className="text-gray-900 font-bold hover:underline cursor-pointer"
              >
                {formatPathName(value)}
              </Link>
            )}
          </React.Fragment>
        );
      })}
    </nav>
  );
}
